import { FormsGroup } from './FormsGroup';
import { FormsInput } from './FormsInput';
import { FormsText } from './FormsText';
import { FormsFormik } from './FormsFormik';
import { FormsSubmit } from './FormsSubmit';
import { FormsFieldSet } from './FormsFieldSet';
import { Form as FormsForm } from 'antd';
import { FormsSelect } from './FormsSelect';
import { FormsCheckbox } from './FormsCheckbox';
import { FormsStateSelect } from './FormsStateSelect';
import { FormsAddress } from './FormsAddress';
import { FormsEnumSelect } from './FormsEnumSelect';
import { FormsContacts } from './FormsContacts';
import { FormsTextArea } from './FormsTextArea';
import { FormsAsyncSelect } from './FormsAsyncSelect';
import { FormsDate } from './FormsDate';
import { FormsNumber } from './FormsNumber';
import { FormsRadio } from './FormsRadio';
import { FormsYesNo } from './FormsYesNo';
import { FormsFieldChange } from './FormsFieldChange';
import { FormsMoney } from './FormsMoney';
import { FormsDeferAttach } from './FormsDeferAttach';
import { FormsErrorMessage } from './FormsErrorMessage';
import { FormsPhoneInput as FormsPhone } from './FormsPhoneInput';
import { FormsTreeSelect } from './FormsTreeSelect';

export const Form = Object.assign(FormsForm, {
  Group: FormsGroup,
  Input: FormsInput,
  TextArea: FormsTextArea,
  Text: FormsText,
  Formik: FormsFormik,
  Submit: FormsSubmit,
  FieldSet: FormsFieldSet,
  Select: FormsSelect,
  TreeSelect: FormsTreeSelect,
  Checkbox: FormsCheckbox,
  StateSelect: FormsStateSelect,
  Address: FormsAddress,
  EnumSelect: FormsEnumSelect,
  Contacts: FormsContacts,
  Phone: FormsPhone,
  AsyncSelect: FormsAsyncSelect,
  Date: FormsDate,
  Number: FormsNumber,
  Radio: FormsRadio,
  YesNo: FormsYesNo,
  FieldChange: FormsFieldChange,
  Money: FormsMoney,
  DeferAttach: FormsDeferAttach,
  ErrorMessage: FormsErrorMessage,
});

export { useAppFindFormik, useAppSubmitFormik } from './FormsContext';
export { useFieldSet } from './FormsFieldSet';
export { INITIAL_CONTACT } from './FormsContacts';
export type { FormRadioOption } from './FormsRadio';
